import { cn } from "@/lib/utils";
import appConfig from "@/config/app.config.json";

export const Logo = ({ className }) => {
  const src = appConfig?.branding?.logoUrl;
  const alt =
    appConfig?.branding?.companyName
      ? `${appConfig.branding.companyName}${
          appConfig.branding.tagline ? ` — ${appConfig.branding.tagline}` : ""
        }`
      : "Logo";

  if (!src) return null;

  return (
    <img
      data-testid="company-logo"
      src={src}
      alt={alt}
      className={cn(
        "h-10 md:h-12 lg:h-14 w-auto object-contain select-none block",
        className
      )}
      draggable={false}
    />
  );
};
